import { Component, Inject } from "@angular/core";
import { DiscoveryService } from "../discovery.service";

@Component({
  selector: "hydra-navbar",
  templateUrl: "./hydra-navbar.component.html",
  styleUrls: ["./hydra-navbar.component.scss"]
})
export class NavbarComponent {
  public constructor(@Inject(DiscoveryService) private documentationService: DiscoveryService) {
  }

  /// Example APIs:
  /// https://wikibus-test.gear.host/ - by tpluscode
  /// https://screening-events.herokuapp.com/ - by angelov

  public documentationUrl = "";

  public async onLoadClick(): Promise<void> {
    if (!!this.documentationUrl) {
      await this.documentationService.loadApiDocumentation(this.documentationUrl);
    }
  }
}
